import { billingApi } from "../../api/endpoints.js";

/**
 * Inicia la compra de un paquete y REDIRIGE al checkout de Mercado Pago.
 *
 * REGLA DE ORO: el redirect NO acredita nada; la app solo abre el checkout. Los
 * créditos se otorgan cuando la pasarela confirma el pago por webhook. `backUrl`
 * es a dónde vuelve el usuario tras pagar (su tablero); al volver, el saldo se
 * relee y refleja la acreditación si el webhook ya llegó.
 *
 * Mismo flujo para padre y terapeuta (el backend valida la audiencia del paquete
 * contra el rol). Lanza si el backend rechaza (paquete inválido, rol, etc.).
 */
export async function irACheckout(productCodigo: string, backUrl?: string): Promise<void> {
  const destino = backUrl ?? window.location.href;
  const { checkoutUrl } = await billingApi.comprar({ productCodigo, backUrl: destino });
  window.location.assign(checkoutUrl);
}
